import { inject } from '@angular/core';

import { FeatureFlagKey, FeatureFlagsStore } from '@mitsubishi/core';

/**
 * Whether the flag-gated study page is on for this session — the one predicate every P1 branch reads
 * (the facade's read source, the resolvers, the patch handler). Injection context only. Flags are loaded
 * by the app initializer before routing starts, so the answer is stable for the session. Grep target for
 * the P4 decommission.
 */
export function isNewStudyPageEnabled(): boolean {
  return inject(FeatureFlagsStore).isEnabled(FeatureFlagKey.NEW_STUDY_PAGE)();
}
